// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"028d7a35","395":"f4154150","411":"41fea4fa","634":"6c41525c","654":"8fff7866","878":"f9a3c17f"}[chunkId] + ".chunk.js";
};